<template>
    <div v-if="activeSite">
        <h3 class="mb-4">
            Contenido Temático
            <b-button
                v-if="isUserStudenTeacherOrBetter"
                class="ml-2"
                variant="primary"
                @click="onCreate()"
            >
                <b-icon-plus /> Agregar
            </b-button>
        </h3>

        <template v-if="getActiveSiteThematicContents">
            <p
                class="tall-line-height"
                v-for="(content, index) in getActiveSiteThematicContents"
                :key="content.id"
            >
                <b-button
                    v-if="isUserStudenTeacherOrBetter"
                    variant="warning"
                    size="sm"
                    class="ml-2"
                    @click="onEdit(content)"
                >
                    <b-icon-pencil />
                </b-button>
                <b-button
                    v-if="isUserStudenTeacherOrBetter"
                    variant="danger"
                    size="sm"
                    class="ml-2"
                    @click="onDelete(content)"
                >    <b-icon-trash-fill />
                </b-button>
                <br v-if="isUserStudenTeacherOrBetter" />

                <strong>{{ index + 1 }}. {{ content.title }}</strong>
                <br />
                {{ content.description }}
            </p>
        </template>
        <p v-else>No existe ningún contenido temático para este sitio web.</p>

        <!-- Create/Update Thematic Contents Modal -->
        <ThematicContentCreateUpdateModal v-if="isUserStudenTeacherOrBetter" />
    </div>
</template>

<script>
import ThematicContentCreateUpdateModal from './ThematicContentCreateUpdateModal'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'SiteThematicContent',
    components: {
        ThematicContentCreateUpdateModal
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedCrudObject'
        ]),
        ...mapGetters([
            'isUserStudenTeacherOrBetter',
            'getActiveSiteThematicContents',
            'getActiveSiteIdentifiers'
        ])
    },
    methods: {
        ...mapActions([
            'deleteSiteThematicContent',
            'readCourseSiteByAcademicPeriod'
        ]),
        onCreate () {
            this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            this.$bvModal.show('modal-create-thematic-content')
        },
        onEdit (thematicContent) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', thematicContent)
            this.$bvModal.show('modal-create-thematic-content')
        },
        async onDelete (thematicContent) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', thematicContent)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar el contenido temático.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDelete()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDelete () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = { courseSiteId: this.activeSite.id, contentId: this.selectedCrudObject.id }
                await this.deleteSiteThematicContent(payloadData)
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
                this.$root.infoToast('El contenido temático ha sido eliminado exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar el contenido temático, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        }
    },
    created () {
        this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
    }
}
</script>
